import { useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../components/main/Loader";
import { AdapterReportFatturatoOpe, FiltersFatOp } from "../../helpers/adapter/filters/AdapterFilterReportOp";
import { initialParams, IPagination } from "../../helpers/PaginationHelper";
import { useGetReportFatturatoOpeMutation } from "../../store/services/ReportService";
import { saveAs } from 'file-saver';
import { useGetUserRoleQuery } from "../../store/services/LookUpService";
import ReportFatturatoOpeFilters from "../../components/filters/ReportFatturatoOpeFilters";

export default function ReportFatturatoOpe() {
    const [queryParams, setQueryParams] = useState<IPagination>(initialParams);
    const [filterParams, setFilterParams] = useState<any>(null);
    let { data: operatoreData, isLoading: isLoadingOp } = useGetUserRoleQuery({role: 'Operatore' });
    const [getReportFatturatoOpe, requestReport] = useGetReportFatturatoOpeMutation()

    const handleSetFilter = async (dataFilter: FiltersFatOp) => {
        const mapFilter: any = AdapterReportFatturatoOpe(dataFilter);
        setFilterParams(mapFilter);
        setQueryParams(initialParams);
        let result: any = await getReportFatturatoOpe(mapFilter);

        if ('error' in result) {
            console.log('ERROR DOWNLOAD')
        } else {
            saveAs(result?.data, `StatisticheFatturatoOperatori_${Date.now()}.xlsx`)
            toast.success(`Report scaricato`);
        }
    }

    return(
        <>
            {requestReport?.isLoading || isLoadingOp ? <Loader /> : null}
            <ReportFatturatoOpeFilters methodParent={handleSetFilter} operatoreData={operatoreData} />
                {requestReport?.isError 
                ? 
                <div className="mt-8 bg-red-100 border-l-4 border-red-500 text-red-700 p-4" role="alert">
                    <p className="font-bold">Attenzione</p>
                    <p>Nessun risultato presente per i parametri selezionati</p>
                </div>
                : null
            }
        </>
    )
}